import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaArrowTrendUp, FaPeopleGroup, FaWifi } from 'react-icons/fa6';

import { EndFlag, QLogo } from '@quizzach/assets';
import { Navigation } from '@quizzach/components';
import { Reveal } from '@quizzach/motion';
import { AboutPage, AboutSec, AboutSections, PageHead } from '@quizzach/styles';
import { scrollToTop } from '@quizzach/utils';

export const AboutUs = () => {
	const { t } = useTranslation();

	useEffect(() => {
		scrollToTop();
	}, []);

	const sections = [
		{
			icon: <EndFlag />,
			title: t('footer.aboutUs.visionTitle'),
			text: t('footer.aboutUs.visionText'),
		},
		{
			icon: <QLogo />,
			title: t('footer.aboutUs.quizzesTitle'),
			text: t('footer.aboutUs.quizzesText'),
		},
		{
			icon: <FaPeopleGroup color='var(--teal-dark)' />,
			title: t('footer.aboutUs.togetherTitle'),
			text: t('footer.aboutUs.togetherText'),
		},
		{
			icon: <FaWifi color='var(--teal-dark)' />,
			title: t('footer.aboutUs.techTitle'),
			text: t('footer.aboutUs.techText'),
		},
		{
			icon: <FaArrowTrendUp color='var(--teal-dark)' />,
			title: t('footer.aboutUs.growthTitle'),
			text: t('footer.aboutUs.growthText'),
		},
	];

	return (
		<AboutPage>
			<Navigation />

			<PageHead>
				<Reveal as='h1'>{t('info.aboutUs')}</Reveal>
			</PageHead>

			<AboutSections data-id='about-us-container'>
				{sections.map((section, index) => (
					<Reveal key={section.title}>
						<AboutSec $flip={index % 2 === 1} $first={index === 0}>
							<span className='ic'>{section.icon}</span>
							<div className='tx'>
								<span className='num'>
									{String(index + 1).padStart(2, '0')}
								</span>
								<h2>{section.title}</h2>
								<p>{section.text}</p>
							</div>
						</AboutSec>
					</Reveal>
				))}
			</AboutSections>
		</AboutPage>
	);
};
